import React, { Component } from "react";
import _ from "lodash";
import { Link } from "gatsby";
import "./PostTags.scss"

class PostTags extends Component {
  render() {
    const { tags } = this.props;
    return (
      <div className="post-tag-container">
        {tags &&
          tags.map(tag => (
            <Link
              className="post-tag__link"
              key={tag}
              style={{ textDecoration: "none" }}
              to={`/tags/${_.kebabCase(tag)}`}
            >
              <button className="post-tag__button" type="button">{tag}</button>
            </Link>
          ))}
      </div>
    );
  }
}

export default PostTags;
